var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.player)?_c('span',{staticClass:"span-container",attrs:{"title":_vm.onlineStatus}},[_c('player-icon-shape',{attrs:{"filled":_vm.iconFilled,"iconColour":_vm.iconColour,"shape":_vm.player.shape}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }